namespace TabAurous.Production {
    export interface JobWorkReceiptRow {
        TransId?: number;
        TransDate?: string;
        VoucherTypeId?: number;
        VoucherNo?: string;
        PartyId?: number;
        LedgerName?: string;
        DepartmentId?: number;
        UserId?: number;
        Username?: string;
        EmployeeId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        NetAmount?: number;
        TaxAmount?: number;
        GrossAmount?: number;
        RoundOff?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        CCNetAmount?: number;
        CCTaxAmount?: number;
        CCGrossAmount?: number;
        CCRoundOff?: number;
        RefVoucherId?: number;
        RefTransId?: number;
        CompanyId?: number;
        FinancialYearId?: number;
        ItemDetails?: JobWorkReceiptItemsRow[];
        TaxDetails?: JobWorkReceiptTaxRow[];
    }

    export namespace JobWorkReceiptRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Production.JobWorkReceipt';
        export const deletePermission = 'Production:JobWorkReceipt:Delete';
        export const insertPermission = 'Production:JobWorkReceipt:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:JobWorkReceipt:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherTypeId = "VoucherTypeId",
            VoucherNo = "VoucherNo",
            PartyId = "PartyId",
            LedgerName = "LedgerName",
            DepartmentId = "DepartmentId",
            UserId = "UserId",
            Username = "Username",
            EmployeeId = "EmployeeId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            NetAmount = "NetAmount",
            TaxAmount = "TaxAmount",
            GrossAmount = "GrossAmount",
            RoundOff = "RoundOff",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            CCNetAmount = "CCNetAmount",
            CCTaxAmount = "CCTaxAmount",
            CCGrossAmount = "CCGrossAmount",
            CCRoundOff = "CCRoundOff",
            RefVoucherId = "RefVoucherId",
            RefTransId = "RefTransId",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            ItemDetails = "ItemDetails",
            TaxDetails = "TaxDetails"
        }
    }
}
